import { UserSetting } from "../global/types";
import { collectBasicNavPaths } from "./navigation";

export type AppMode = 'basic' | 'full';

/** Missing/undefined preference == 'full' everywhere — no behavior change for existing users. */
export function getAppMode(settings: UserSetting | null | undefined): AppMode {
    return settings?.preferences?.appMode ?? 'full';
}

/**
 * Reachable in basic mode but deliberately not in the sidebar:
*/
const EXTRA_BASIC_PATHS = [
    '/dashboard/index',
    '/dashboard/pdf/map-columns',
];

export const BASIC_MODE_ALLOWED_PATHS: string[] = [
    ...collectBasicNavPaths(),
    ...EXTRA_BASIC_PATHS,
];

export function isPathAllowedInBasicMode(pathname: string): boolean {
    return BASIC_MODE_ALLOWED_PATHS.some(p => pathname === p || pathname.startsWith(p + '/'));
}
